module.exports = __webpack_public_path__ + "img/topic-active.f59c4851.svg";